import { motion } from "framer-motion";
import { cn } from "@/lib/cn";

const SPRING = { type: "spring" as const, stiffness: 300, damping: 30 };

export function RadioDot({ selected }: { selected: boolean }) {
  return (
    <div
      className={cn(
        "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2",
        selected
          ? "border-[var(--color-primary)]"
          : "border-[var(--color-text-muted)]",
      )}
    >
      {selected && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={SPRING}
          className="h-2.5 w-2.5 rounded-full bg-[var(--color-primary)]"
        />
      )}
    </div>
  );
}
